import i18n from './index';

type NsModule = { default: Record<string, unknown> };

const ruModules = import.meta.glob<NsModule>('./ru/{client,admin,courier,platform}.json');

const loaded = new Set<string>();

/** Fetches a lazily-split namespace's ru bundle once and registers it with i18next. */
export async function loadNamespace(
  ns: 'client' | 'admin' | 'courier' | 'platform',
): Promise<void> {
  if (loaded.has(ns)) return;
  loaded.add(ns);
  const ru = await ruModules[`./ru/${ns}.json`]!();
  i18n.addResourceBundle('ru', ns, ru.default, true, true);
}
